// wp/ACTIONS: the confirm step of a task row's hover Delete (a list row, a subtask row). A task
// delete is for good (no undo record, no archive on a task): the dialog says so, as the drawer's
// "Delete task" does. The server decides; a refusal is the write's toast.
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  toast,
} from "@companyos/ui";
import type { Api } from "../../api/client";
import type { CompanyAccess } from "../company";
import { taskRef } from "./model";
import { useTaskWrites } from "./task-writes";

/** `number` when the row knows it (a list row's summary does not). */
export type DeletingTask = { id: string; number?: number; title: string };

const refOf = (t: DeletingTask) => (t.number !== undefined ? taskRef({ number: t.number }) : null);

export function DeleteTaskDialog({
  api,
  company,
  task,
  onClose,
}: {
  api: Api;
  company: CompanyAccess;
  task: DeletingTask | null;
  onClose: () => void;
}) {
  const writes = useTaskWrites(api, company);
  return (
    <AlertDialog open={task !== null} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-slot="task-delete-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {(task && refOf(task)) ?? "this task"}?</AlertDialogTitle>
          <AlertDialogDescription>
            “{task?.title}” goes for everyone; its subtasks stay, without a parent. This can't be
            undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep it</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={() => {
              if (task)
                writes.remove(task.id, {
                  onSuccess: () =>
                    toast.add({
                      title: `${refOf(task) ?? "Task"} deleted`,
                      description: task.title,
                    }),
                });
              onClose();
            }}
          >
            Delete task
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
